/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const inventoryBatches = sqliteTable('inventory_batches', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  inventory_item_id: text('inventory_item_id'),
  batch_number: text('batch_number'),
  expiry_date: text('expiry_date'),
  received_date: text('received_date'),
  status: text('status'),
  remarks: text('remarks'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
